const CLAIMED_NO_PROGRAMME_SESSION_KEY = 'acesso_claimed_no_programme_session'

export function markClaimedAnonymousContinuationAllowed(): void {
  try {
    sessionStorage.setItem(CLAIMED_NO_PROGRAMME_SESSION_KEY, '1')
  } catch {
    /* best-effort */
  }
}

export function clearClaimedAnonymousContinuationAllowed(): void {
  try {
    sessionStorage.removeItem(CLAIMED_NO_PROGRAMME_SESSION_KEY)
  } catch {
    /* best-effort */
  }
}

export function hasClaimedAnonymousContinuationAllowed(): boolean {
  try {
    return sessionStorage.getItem(CLAIMED_NO_PROGRAMME_SESSION_KEY) === '1'
  } catch {
    return false
  }
}
